import { useMemo } from 'react';
import { useGetNonManagedStats, useGetStats } from './use-get-stats';

function useHasComplianceIssues(propertyManagerId?: string | null) {
    const { isLoading: isStatsLoading, data: portfolioStats } = useGetStats(propertyManagerId);
    const { isLoading: isNonManagedStatsLoading, data: nonManagedStats } = useGetNonManagedStats();

    const hasDiComplianceIssues = useMemo(() => {
        if (isStatsLoading || portfolioStats === undefined) {
            return false;
        }

        return (portfolioStats.portfolioStats.UNRESOLVED_ACTIVE_NOTICES > 0
            || portfolioStats.portfolioStats.UNPAID_OVERDUE_INVOICES > 0
            || portfolioStats.portfolioStats.NON_COMPLIANT_QUOTATIONS > 0);
    }, [portfolioStats, isStatsLoading]);

    const hasNonManagedComplianceIssues = useMemo(() => {
        if (isNonManagedStatsLoading || nonManagedStats === undefined) {
            return false;
        }

        return nonManagedStats.nonManagedPortfolioStats.COMPLIANCE_ISSUES > 0;
    }, [nonManagedStats, isNonManagedStatsLoading]);

    return {
        hasDiComplianceIssues,
        hasNonManagedComplianceIssues,
    };
}

export { useHasComplianceIssues };
